export const templatesList = [
  "aurora",
  "halo",
  "david",
  "darcia",
  "lumen",
  "poncia",
  "nissy",
  "glad",
  "cobalt",
  "atlas",
  "noir",
  "fredline",
  "junior",
  "azurill",
  "bronzor",
  "chikorita",
  "ditto",
  "gengar",
  "glalie",
  "kakuna",
  "leafish",
  "nosepass",
  "onyx",
  "pikachu",
  "rhyhorn",
] as const;

export type Template = (typeof templatesList)[number];

// Templates reserved for the Pro plan. Single source of truth shared by the
// builder (selection gating) and the server (export enforcement).
export const premiumTemplates: readonly Template[] = [
  "lumen",
  "poncia",
  "nissy",
  "glad",
  "cobalt",
  "atlas",
  "noir",
  "fredline",
  "junior",
];

export const isPremiumTemplate = (template: string): boolean =>
  (premiumTemplates as readonly string[]).includes(template);
